export default __webpack_public_path__ + "static/the-mom-test-97908d65afc4d59891ddf326665eeefb.jpg";